import { createMuiStyles } from '../../utils/mui';

export const homeStyles = createMuiStyles({
  triangleShapeContainer: {
    position: 'relative',
    overflow: 'hidden',
  },
  triangleShape: {
    position: 'absolute',
    right: 0,
    top: 0,
    zIndex: -1,
    width: {
      md: '50vw',
      lg: '55vw',
    },
    maxHeight: '175vh',
    maxWidth: '55rem',
    height: 'auto',
    display: {
      xs: 'none',
      md: 'block',
    },
  },
});
